// extracted by mini-css-extract-plugin
export var container = "lpLogoSoupSection-module--container--aed54";
export var heading = "lpLogoSoupSection-module--heading--6eec3";
export var logo = "lpLogoSoupSection-module--logo--33e02";
export var logoWrapper = "lpLogoSoupSection-module--logoWrapper--01a16";
export var logosContainer = "lpLogoSoupSection-module--logosContainer--095a2";
export var logosRow = "lpLogoSoupSection-module--logosRow--bce25";
export var slideLeft = "lpLogoSoupSection-module--slide-left--c968c";
export var staticLogos = "lpLogoSoupSection-module--staticLogos--ab9e7";